import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";
import React from "react";
import { useQuery } from "react-query";
import { ReferentialItemDto, UserRoles } from "../../api";
import { useCommonHooks } from "../../hooks";
import { ETLCodes } from "../../locales";
import { nameof } from "../../utils";

export interface UserRoleSelectProps
  extends Pick<IFGSelectInputProps<any>, "requiredMark"> {
  name: string;
  label?: string;
  showAdmin?: boolean;
}

export const UserRoleSelect: React.FC<UserRoleSelectProps> = ({
  name,
  label,
  showAdmin = true,
  ...fgSelectInputProps
}) => {
  const { t, apis } = useCommonHooks();

  const { data, isFetching } = useQuery("ref-user-roles", async () => {
    var res = await apis.referential.roles();
    if (!showAdmin) {
      return res.filter((c) => c.keyValue !== UserRoles.Admin);
    }
    return res;
  });

  return (
    <FGSelectInput
      label={label || t(ETLCodes.Role)}
      name={name}
      items={data}
      loading={isFetching}
      displayField={nameof<ReferentialItemDto>("displayValue")}
      valueField={nameof<ReferentialItemDto>("idValue")}
      isFilterable={true}
      {...fgSelectInputProps}
    />
  );
};
